
import { Alert } from '../../Models/Alert';
import { Reducer, combineReducers } from 'redux';
import {
  NotificationAction,
  SHOW_ALERT,
  REMOVE_ALERT
} from './actions';
import { any, append, reject } from 'ramda';

export interface NotificationState {
  notifications : Alert[];
}

const INITIAL_STATE: NotificationState = {
  notifications : [],
}

const notificationsReducer = (state: Alert[] = INITIAL_STATE.notifications, action: NotificationAction): Alert[] => {
  switch(action.type) {
    case SHOW_ALERT:
      if(!any((a: Alert) => a.message === action.payload.notification.message && a.type === action.payload.notification.type, state)
        && action.payload.notification.message.toLowerCase() !== "cannot read property 'accessToken' of undefined"
        && action.payload.notification.message.toLowerCase() !== "cannot read property 'json' of undefined"
        && action.payload.notification.message.toLowerCase() !== 'unexpected end of json input'
        && action.payload.notification.message.toLowerCase() !== 'unexpected token s in json at position 0'
        && action.payload.notification.message.toLowerCase() !== 'unexpected token m in json at position 0'
      ) {
        return append(action.payload.notification, state);
      }
      return state;
    case REMOVE_ALERT:
      return reject((n: Alert) => n.id === action.payload.notificationId, state);
    default:
      return state;
  }
};



export const notificationReducer: Reducer<NotificationState> = combineReducers<NotificationState>({
  notifications: notificationsReducer,
});
